import logo from "./logo1.png";
import "./App.css";
import {
  Container,
  Row,
  Button,
  Form,
  ListGroup,
  ListGroupItem,
  Image,
  Col,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { stackOffsetNone } from "d3";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import spinner from "./Spinner.svg";

export default function Main() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [disableSurname, setdisableSurname] = useState(true);
  const [flagErrorSur, setFlagErrorSur] = useState(true);
  const [flagErrorNam, setFlagErrorNam] = useState(true);
  const [labelErrorCamp, setlabelErrorCamp] = useState("");
  const [flagabc, setFlagabc] = useState(true);

  const [list1Hidden, setlist1Hidden] = useState(true);
  const [list2Hidden, setlist2Hidden] = useState(true);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [listneo, setlistneo] = useState([]);
  const [listsearchpeople, setlistsearchpeople] = useState([]);
  const [JSONname, setJSONname] = useState("");
  const [labelName, setLabelName] = useState("Nome e Cognome");
  const [placeName, setPlaceName] = useState("Mario Rossi");

  const [hiddenSurname, setHiddenSurname] = useState(true);
  const [labelButton, setLabelButton] = useState("Non è in questa Lista ?");
  const [flagsur, setFlagSur] = useState(true);
  const [flagfirst, setFlagfirst] = useState(true);
  const [labelError, setLabelError] = useState(true);

  const [loadingHidden, setloadingHidden] = useState(false);
  const [loadError, setLoadError] = useState(true);

  const handleSetName = (e) => {
    setName(e);
    handleSubmit();
  };

  async function handleSearchPersonJSON(index, JSONname) {
    setloadingHidden(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_populateneo4j}?json_name_file=${JSONname}&index=${index}`

        //"/searchPerson.json"
      );

      navigate("/List3", {
        replace: true,
        state: {
          PersonFromPersonId: response.data.person_id,
        },
      });
      setloadingHidden(false);
    } catch (error) {
      console.error(error);
      setloadingHidden(false);
      setLoadError(true);
    }
  }

  const handleSubmit = () => {
    if (flagsur) {
      if (name || name !== "" || name.length > 3) {
        getPersonFromNeo4j();
      }
    }
  };

  const handleNotList = () => {
    //searchPerson(firstName: str, lastName: str, threshold: str, country: str)
    searchPerson();
  };

  function handleList(id) {
    navigate("/List1", { replace: true, state: { PersonFromID: id } });
  }

  async function searchPerson() {
    setFlagSur(false);
    setPlaceName("Mario");
    setlist1Hidden(true);
    setLabelName("Nome");
    setHiddenSurname(false);
    setdisableSurname(false);
    setLabelButton("Cerca Persona non in Lista");

    if (surname && name) {
      setlabelErrorCamp("");
      setLabelError(true);
      setIsLoading(true);
      setlist1Hidden(true);
      setlist2Hidden(false);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_searchperson}?firstName=${name}&lastName=${surname}&threshold=1&country=italia`
          //"/searchPerson.json"
        );

        let list_2_hidden = [];
        for (let i = 0; i < response.data.people.length; i++) {
          setJSONname(response.data.json_name_file);
          list_2_hidden.push(response.data.people[i][1]);
        }
        setlistsearchpeople(list_2_hidden);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    }
    if (!surname) {
      if (flagabc) {
        setlabelErrorCamp("");
        setFlagabc(false);
      }
      if (!flagabc) {
        setlabelErrorCamp("(Error Cognome!)");
      }
    }
    if (!name) {
      setlabelErrorCamp("(Error Nome!)");
      setFlagErrorNam(false);
    }
  }
  //1 lista
  //getpersonfromneo4j
  //getpersonfromid
  //correggere informazioni

  //2 lista
  //searchperson
  //populateneo4j
  //getpersonfrompersonID

  async function getPersonFromNeo4j() {
    setIsLoading(true);
    setlist2Hidden(true);
    setlist1Hidden(false);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_getpersonfromneo4j}?name=${name}`
      );

      let list_1_hidden = [];
      for (let i = 0; i < response.data.Persone.length; i++) {
        list_1_hidden.push(response.data.Persone[i]);
      }
      setlistneo(list_1_hidden);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Container className="App">
      <Row>
        <Row
          style={{
            borderBottom: "1px solid #ccc",
          }}
        >
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
          </header>
        </Row>
        <div hidden={loadingHidden}>
          <Row>
            <Form onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <p hidden={loadError}>Errore Caricamento!</p>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label
                      style={{
                        fontSize: "2em",
                        margin: ".67em 0",
                      }}
                    >
                      Cerca Persona {labelErrorCamp}
                    </Form.Label>
                  </Form.Group>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>{labelName}</Form.Label>
                      <Form.Control
                        onChange={(e) => handleSetName(e.target.value)}
                        value={name}
                        autoComplete="off"
                        placeholder={placeName}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSubmit(e);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col hidden={hiddenSurname}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Cognome</Form.Label>
                      <Form.Control
                        disabled={disableSurname}
                        onChange={(e) => setSurname(e.target.value)}
                        value={surname}
                        placeholder="Rossi"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSubmit(e);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
            </Form>
          </Row>

          <Row hidden={list1Hidden} style={{ marginBottom: "4rem" }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                onClick={handleNotList}
                className="bottonehome"
                style={{
                  width: "14rem",
                }}
              >
                {labelButton}
              </Button>
            </div>
            <ListGroup style={{ textAlign: "initial" }}>
              {isLoading ? (
                <>
                  <ListGroupItem>
                    <Skeleton animation="wave" />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                </>
              ) : (
                listneo.map((item) => (
                  <ListGroupItem
                    onClick={() => handleList(item.id, item.fullName)}
                    key={item.id}
                  >
                    {item.fullName} --- {item.dateOfBirth} ---{" "}
                    {item.nationality}
                  </ListGroupItem>
                ))
              )}
            </ListGroup>
          </Row>
          <Row hidden={flagsur} style={{ marginBottom: "4rem" }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                onClick={handleNotList}
                className="bottonehome"
                style={{
                  width: "14rem",
                }}
              >
                {labelButton}
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                marginTop: "1rem",
                justifyContent: "end",
              }}
            >
              <Button
                onClick={() => window.location.reload()}
                className="bottonehome"
                style={{
                  width: "10rem",
                }}
              >
                Torna in Home
              </Button>
            </div>
            <ListGroup style={{ textAlign: "initial" }}>
              {isLoading ? (
                <>
                  <ListGroupItem>
                    <Skeleton animation="wave" />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Skeleton />
                  </ListGroupItem>
                </>
              ) : (
                listsearchpeople.map((item, index) => (
                  <ListGroupItem
                    onClick={() => handleSearchPersonJSON(index, JSONname)}
                    key={item.id}
                  >
                    {item.forename} {item.surname}
                  </ListGroupItem>
                ))
              )}
            </ListGroup>
          </Row>
        </div>
        <Container hidden={!loadingHidden} style={{ marginTop: "1rem" }}>
          <p>Caricamento in corso...</p>
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </Container>
      </Row>
    </Container>
  );
}
